module.exports = __webpack_public_path__ + "fonts/1b99d71c-c066-4ce3-b4af-38dfd9fe3d85.eb951908.woff";